"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = exports.Node = void 0;
class Node {
    constructor(value, selectionmode = 'INHERIT_SELECTION') {
        this.tree = null;
        this.sort = (order) => (a, b) => {
            const al = a;
            const bl = b;
            return order === 'desc'
                ? `${bl.getValue().name || ''}`.localeCompare(`${al.getValue().name || ''}`)
                : `${al.getValue().name || ''}`.localeCompare(`${bl.getValue().name || ''}`);
        };
        this.value = value;
        this.selectionmode = selectionmode;
        this.children = [];
    }
    sortChildren(order) {
        this.children = this.children.sort(this.sort(order));
    }
    addChildren(node) {
        node.setParentNode(this);
        if (this.getSelected() === true &&
            this.selectionmode === 'INHERIT_SELECTION') {
            node.setSelected(true);
        }
        this.children.push(node);
        if (this.tree) {
            this.tree.add(node);
        }
    }
    toJSON(key) {
        return `${JSON.stringify(this.value)} - ${this.children.length} - ${this.selected} - ${!!this.parent}`;
    }
    setTree(tree) {
        this.tree = tree;
    }
    setSelected(value) {
        this.selected = value;
        if (this.selectionmode === 'INHERIT_SELECTION') {
            this.getChildren().forEach((c) => c.setSelected(value));
        }
    }
    setChildren(nodes) {
        this.children = [];
        nodes.forEach((node) => this.addChildren(node));
    }
    setValue(value) {
        this.value = value;
    }
    setParentNode(node) {
        this.parent = node;
    }
    setLoading(value) {
        this.loading = value;
    }
    setExpanded(value) {
        this.expanded = value;
    }
    getTree() {
        return this.tree;
    }
    getSelected() {
        return this.selected;
    }
    getSelectMode() {
        if (this.selectionmode === undefined) {
            return 'INHERIT_SELECTION';
        }
        return this.selectionmode;
    }
    getValue() {
        return this.value;
    }
    getParentNode() {
        return this.parent;
    }
    getLoading() {
        return this.loading;
    }
    getExpanded() {
        return this.expanded;
    }
    findNode(fn) {
        if (fn(this.value)) {
            return this;
        }
        else if (this.children.length > 0) {
            let i;
            let result = null;
            for (i = 0; result == null && i < this.children.length; i++) {
                result = this.children[i].findNode(fn);
            }
            return result;
        }
        return null;
    }
    getChildren() {
        return this.children;
    }
    deleteChildren(x) {
        if (this.children.length > 0) {
            this.children = this.children.filter((y) => y !== x);
        }
    }
    getDescendants() {
        if (this.children.length === 0) {
            return this.children;
        }
        else {
            let descendants = [];
            let i = 0;
            let result = null;
            for (i = 0; result == null && i < this.children.length; i++) {
                result = this.children[i].getDescendants();
                descendants = descendants.concat(result);
            }
            return descendants;
        }
    }
    removeChildren() {
        this.children = [];
    }
}
exports.Node = Node;
class Tree {
    constructor(root) {
        this.nodes = new Set();
        this.root = root;
        this.revision = 0;
        root.setExpanded(true);
        this.add(root);
    }
    has(node) {
        return this.nodes.has(node);
    }
    update() {
        this.revision += 1;
    }
    add(node) {
        node.setTree(this);
        this.nodes.add(node);
        this.update();
    }
    getRoot() {
        return this.root;
    }
    getNodes() {
        return Array.from(this.nodes);
    }
    delete(node) {
        const children = node.getChildren();
        for (let i = 0; i < children.length; i++) {
            this.delete(children[i]);
        }
        this.nodes.delete(node);
    }
    clone() {
        return Object.create(this);
    }
    diff(tree) {
        const difference = new Set(this.nodes);
        for (const elem of tree.getNodes()) {
            difference.delete(elem);
        }
        return difference;
    }
    intersection(tree) {
        const intersection = new Set(this.nodes);
        for (const elem of tree.getNodes()) {
            if (this.has(elem)) {
                intersection.add(elem);
            }
        }
        return intersection;
    }
    equals(tree) {
        return this.diff(tree).size === 0;
    }
}
exports.Tree = Tree;
//# sourceMappingURL=Tree.js.map